<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { supabase } from "@/lib/supabaseClient";

let latestCustomer = ref()
let name = ref()
let number = ref("0")
let timeAgo = ref()
let updatedAt = ref()
let copySuccess = ref()

async function getLatestCustomer() {
  latestCustomer.value = await supabase
      .from("customers")
      .select("*")
      .order("updated_at", { ascending: false })
      .limit(1)
  latestCustomer.value = latestCustomer.value['data'][0]
  name.value = latestCustomer.value['customer_name']
  number.value = latestCustomer.value['customer_number']
  updatedAt.value = latestCustomer.value['updated_at']
  timeAgo.value = calculateTimeAgo()
  if (number.value.search('email verification page') !== - 1){
    console.log("if one")
    number.value = number.value.match(/email verification page:\s*(\d+)/)[1]
  }
  if (number.value.includes("To confirm this change, click here\n<https:")){
    console.log("if two")
    number.value = number.value.match(/<([^>]+)>/)[1]
    number.value = "<a href='"+ number.value + "' target='_blank'>asd</a>"
  }
  if (number.value.includes("accounts.google.com/AccountChooser")){
    console.log("if three")
    number.value = "<a href='"+ number.value + "' target='_blank'>asd</a>"
  }
  console.log("if last")
}

// Function to calculate the "time ago" string
function calculateTimeAgo() {
  const eventTime = new Date(updatedAt.value) // Parse the timestamp
  const now = new Date()
  const seconds = Math.floor((now - eventTime) / 1000)

  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  if (seconds < 60) {
    return `${remainingSeconds} seconds ago`
  } else if (seconds < 3600) {
    return `${minutes} minutes ${remainingSeconds} seconds ago`
  } else if (seconds < 86400) {
    return `${hours} hours ${minutes} minutes ${remainingSeconds} seconds ago`
  } else {
    return `${days} days ${hours} hours ${minutes} minutes ${remainingSeconds} seconds ago`
  }
}

async function copyNumber() {
  try {
    await navigator.clipboard.writeText(number.value);
    copySuccess.value = "Teks berhasil disalin!";
    navigator.clipboard.readText()
        .then(text => {
          console.log('Clipboard content:', text);
        })
        .catch(err => {
          console.error('Failed to read clipboard contents: ', err);
        });

    // Change the number text color to green after copy
    number.value = `<span style="background-color: #42b983; color: white;">${number.value}</span>`; // Dynamically change the number color to green

  } catch (err) {
    copySuccess.value = "Gagal menyalin teks.";
    console.error("Error copying text:", err);
  }
}

onMounted(() => {
  getLatestCustomer()
  // Initial calculation
  timeAgo.value = calculateTimeAgo()

  // Update every second
  const interval = setInterval(() => {
    timeAgo.value = calculateTimeAgo()
  }, 1000)
  const channel = supabase.channel('custom-insert-channel')
      .on(
          'postgres_changes',
          {event: '*', schema: 'public', table: 'customers'},
          (payload) => {
            console.log('Change received!', payload['new'])
            name.value = payload['new']['customer_name']
            number.value = payload['new']['customer_number']
            updatedAt.value = payload['new']['updated_at']
            copySuccess.value = ""
            if (number.value.search('email verification page') !== - 1){
              console.log("if one")
              number.value = number.value.match(/email verification page:\s*(\d+)/)[1]
            }
            if (number.value.includes("To confirm this change, click here\n<https:")){
              console.log("if two")
              number.value = number.value.match(/<([^>]+)>/)[1]
              number.value = "<a href='"+ number.value + "' target='_blank'>asd</a>"
            }
            if (number.value.includes("accounts.google.com/AccountChooser")){
              console.log("if three")
              number.value = "<a href='"+ number.value + "' target='_blank'>asd</a>"
            }
            console.log("if last")
          }
      )
      .subscribe()

  // Cleanup pada unmount
  onUnmounted(() => {
    supabase.removeChannel(channel)
    clearInterval(interval)
  })
})
</script>

<template>
  <div class="text-center container pt-3 ps-1 pe-1">
    <!-- Card Container -->
    <div class="card shadow-lg">
      <div class="card-body">

        <!-- Name -->
        <div class="row mb-3">
          <div class="col">
            <h1>"{{ name }}"</h1>
          </div>
        </div>

        <!-- Number and Copy Button -->
        <div class="row mb-3">
          <div class="col">
            <h1 class="asd fw-bold" v-html="number"></h1> <!-- Bind the dynamically updated number here -->
          </div>
        </div>

        <!-- Time Ago -->
        <div class="row mb-3">
          <div class="col">
            <h6>{{ timeAgo }}</h6>
          </div>
        </div>

        <!-- Copy Button -->
        <div class="row mb-3">
          <div class="col">
            <p class="h5">
              <button class="btn btn-lg btn-primary" @click="copyNumber()">Copy Text</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import 'bootstrap/dist/css/bootstrap.min.css';

/* Optional: Custom Styles */

.btn-lg {
  padding: 1rem 2rem; /* Menyesuaikan padding tombol */
  font-size: 1.25rem; /* Menambah ukuran font */
  width: 100%; /* Membuat tombol memenuhi lebar */
  margin-top: auto; /* Memastikan tombol berada di bagian bawah */
}

.card {
  border-radius: 20px;
}

.card-body {
  padding: 2rem;
}

h3 {
  font-weight: normal;
}

p.lead {
  font-size: 1.25rem;
}

h1.asd {
  font-size: 90px;
}

.text-success {
  font-weight: 600;
}
</style>